import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Services from './components/Services';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';

/** 设为 true 可恢复「用户评价」区块 */
const SHOW_TESTIMONIAL = false;

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Features />
      <About />
      <Services />
      {SHOW_TESTIMONIAL ? <Testimonial /> : null}
      <CTA />
      <Footer />
    </div>
  );
}
